import { toastService } from '@thefarmersfront/kitchen';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT, TOAST_MESSAGE } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [재고관리] 반출 요청 상세 > 엑셀 다운로드 api 요청 훅
 */
const useGetVendorReleaseIdExcelDownload = () => {
  const { runDownloadAsync } = useAsyncHandler();

  const getExcelDownload = useAPI<unknown>({
    endpoint: API_ENDPOINT.STOCK.GET_VENDOR_RELEASE_EXCEL_DOWNLOAD_ID,
    method: 'get',
    responseType: 'blob',
  });

  const requestExcelDownload = async (
    id: number,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    } = {}
  ) => {
    runDownloadAsync(() => getExcelDownload({ pathParams: `/${id}/excel-download` }), {
      onSuccess: () => {
        toastService.addToast({
          message: TOAST_MESSAGE.DOWNLOAD_SUCCESS,
        });
        onSuccess?.();
      },
      onError: (error: TypeErrorResponseData['error']) => {
        toastService.addToast({
          type: 'error',
          message: error.message ?? TOAST_MESSAGE.DEFAULT_ERROR,
        });
        onError?.(error);
      },
    });
  };

  return { requestExcelDownload };
};

export default useGetVendorReleaseIdExcelDownload;
